import { Component, Mixins, VModel, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import EditorJs from '@editorjs/editorjs'

@Component({
    name: 'editorjs',
})
export default class Editorjs extends Mixins<MixinInterface>() {
    @Prop({
        default: () => [
            'header',
            'linkTool',
            'list',
            'embed',
            'quote',
            'table',
            'delimiter',
            'Marker',
            'underline',
        ],
    })
    tools!: any

    @VModel({ required: true }) richtext!: any
    @Prop({ required: true }) id!: string
    editor: null | EditorJs = null

    @Watch('id')
    createEditor() {
        if (this.editor) {
            if (this.richtext) {
                this.editor.render(this.richtext)
                this.editor.caret.focus(true)
            } else {
                this.editor.clear()
            }
        }
    }

    mounted() {
        this.editor = new EditorJs({
            holder: this.id,
            data: this.richtext,
            onReady: () => {
                this.createEditor()
            },
            onChange: async () => {
                await this.onChange()
            },
        })
    }

    async onChange() {
        if (this.editor) {
            await this.editor.save().then(async (outputData: any) => {
                if (outputData.blocks.length > 0) {
                    this.richtext = outputData
                } else {
                    this.richtext = null
                }
                this.$emit('onChange', true)
            })
        }
    }

    destroyed() {
        this.editor?.destroy()
    }
}
